import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges, Renderer2, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EActionTypes } from './enum';
import { IUserPermissionHandler } from './model/CommonModel';
import { IUserRights } from './model/AdminUserModel';
import { GeneralService } from '../services/general.service';
import { Subject, takeUntil } from 'rxjs';
@Directive({
    selector: '[userPermissionHandler]'
})
export class UserPermissionHandlerDirective implements OnInit, OnChanges, OnDestroy {
    @Input() userPermissionHandler: IUserPermissionHandler;
    userRights: IUserRights;
    private destroy$ = new Subject<void>();

    constructor(private elementRef: ElementRef,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document,
        private generalService: GeneralService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['userPermissionHandler'] && !changes['userPermissionHandler'].firstChange) {
            if (!this.userPermissionHandler) {
                this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
                const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
                const msgDivs = parentNode.querySelectorAll('.viewRightCls');
                msgDivs.forEach((el: HTMLElement) => el.remove());
            }
        }
    }

    ngOnInit() {
        if (!this.userPermissionHandler) {
            return;
        }
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation: MutationRecord) => {
                if (mutation.type == "attributes" && mutation.attributeName == "disabled") {
                    this.changeHost();
                }
            });
        });
        observer.observe(this.elementRef.nativeElement, {
            attributes: true,
            childList: true,
            characterData: true
        });
        if (this.generalService.UserPermissions != undefined) {
            this.userRights = this.generalService.getUserPermissionsForModule(this.userPermissionHandler.FunctionId);
            this.changeHost();
        } else {
            this.generalService.userGroupPermissions.pipe(takeUntil(this.destroy$)).subscribe({
                next: (response) => {
                    this.userRights = this.generalService.getUserPermissionsForModule(this.userPermissionHandler.FunctionId);
                    this.changeHost();
                },
                error: (error) => {},
            });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
    
    changeHost() {
        if (this.elementRef && this.elementRef.nativeElement) {
            switch(this.elementRef.nativeElement.nodeName) {
                case 'BUTTON':
                    if ((!this.userRights.CreateRight && this.userPermissionHandler.Action == EActionTypes.CREATE) || (!this.userRights.EditRight && this.userPermissionHandler.Action == EActionTypes.EDIT) ||
                    (!this.userRights.DeleteRight && this.userPermissionHandler.Action == EActionTypes.DELETE) || (!this.userRights.ViewRight && this.userPermissionHandler.Action == EActionTypes.VIEW)) {
                        if (!this.elementRef.nativeElement.getAttribute('disabled')) {
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'style', 'pointer-events: auto');
                        }
                        if (!this.userRights.CreateRight && this.userPermissionHandler.Action == EActionTypes.CREATE) {
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.generalService.CreateRightFalseMessage);
                        }
                        if (!this.userRights.EditRight && this.userPermissionHandler.Action == EActionTypes.EDIT) {
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.generalService.EditRightFalseMessage);
                        }
                        if (!this.userRights.ViewRight && this.userPermissionHandler.Action == EActionTypes.VIEW) {
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.generalService.ViewRightFalseMessage);
                        }
                        if (!this.userRights.DeleteRight && this.userPermissionHandler.Action == EActionTypes.DELETE) {
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.generalService.DeleteRightFalseMessage);
                        }
                    }
                    break;
                case 'DIV':
                    if ((this.userRights == null || !this.userRights.ViewRight) && this.userPermissionHandler.Action == EActionTypes.VIEW) {
                        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
                        const child = document.createElement('div');
                        child.classList.add('viewRightCls');
                        child.innerHTML = this.generalService.ViewRightFalseMessage;
                        let parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
                        parentNode.appendChild(child);
                    }
                    break;
                case 'A':
                    if ((this.userRights == null || !this.userRights.DeleteRight) && this.userPermissionHandler.Action == EActionTypes.DELETE) {
                        this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.generalService.DeleteRightFalseMessage);
                        // to remove event listener
                        const clonedElement = this.elementRef.nativeElement.cloneNode(true);
                        this.elementRef.nativeElement.replaceWith(clonedElement);
                    }
                    break;
                case 'INPUT':
                    if ((this.userRights == null || !this.userRights.EditRight) && this.userPermissionHandler.Action == EActionTypes.EDIT) {
                        if (!this.elementRef.nativeElement.getAttribute('disabled')) {
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
                            this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.generalService.EditRightFalseMessage);
                        }
                    }
                    break;
            }
        }

    }

}

